import {
    VIEWDEALERFORPARTNER_SUCCESS,
    VIEWDEALERFORPARTNER_FAILED,
    RESET_VIEWDEALERFORPARTNER,
    LOADING_VIEWDEALERFORPARTNER,
    NETWORK_ERROR_VIEWDEALERFORPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_VIEWDEALERFORPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case VIEWDEALERFORPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case VIEWDEALERFORPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_VIEWDEALERFORPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_VIEWDEALERFORPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};